"use strict";
export function normalizeBase64Image(uri) {
  return uri.replace(/\\n|[\n\r]/g, "").trim();
}
